import {
    Grid,
    Tooltip,
    Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { useHistory } from 'react-router-dom'
import Routes from '../../../constants/routes'
import { UserRoles } from '../../../constants/user-roles'
import {
    APPOINTMENT_TYPE,
    EVENT_TYPE,
    SLOT_TYPE,
} from '../constant'

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#fff',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 311,
        width: 311,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        shadow: 'rgba(0,0,0,0.25) 10px 0 0',
        padding: '20px',
        borderRadius: '0',
    },
}))(Tooltip)

function WeekCalendarEvent(props) {
    const history = useHistory()

    function handlePatientNameClick(id) {
        history.push(Routes.PROFILE, {
            userId: id,
            role: UserRoles.PATIENT,
        })
    }

    if (props.event.type === EVENT_TYPE.TIMEOFF) {
        return (
            <Grid
                container
                alignItems="center"
                justifyContent="center">
                <Typography noWrap>
                    <strong>{props.title}</strong>
                </Typography>
            </Grid>
        )
    }

    if (props.event.type === EVENT_TYPE.BUSY_SLOT) {
        return (
            <HtmlTooltip
                title={<ToolTipContent {...props.event} />}
                placement="top">
                <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-start">
                    <Grid item>
                        <Typography
                            noWrap
                            className="black">
                            <strong>{props.title}</strong>
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography
                            color="inherit"
                            display="inline"
                            className="capitalize">
                            <a
                                href="#"
                                style={{ color: 'black' }}
                                onClick={(e) => {
                                    e.preventDefault()
                                    handlePatientNameClick(
                                        props.event
                                            .appointment
                                            .patient.id,
                                    )
                                }}>
                                {props.event.appointment
                                    .patient?.name ?? ''}
                            </a>
                        </Typography>{' '}
                        |{' '}
                        <Typography
                            color="inherit"
                            display="inline">
                            {props.event.appointment
                                .type ===
                            APPOINTMENT_TYPE.TELE_HEALTH
                                ? 'Tele-health'
                                : 'In-clinic'}
                        </Typography>
                    </Grid>
                </Grid>
            </HtmlTooltip>
        )
    }

    if (props.event.type === EVENT_TYPE.FREE_SLOT) {
        return (
            <Grid
                container
                alignItems="center"
                justifyContent="flex-start"></Grid>
        )
    }

    return <></>
}

function ToolTipContent(props) {
    return (
        <div className="tooltip-wrapper">
            <div style={{ marginBottom: '10px' }}>
                <span className="date">
                    {props.slot.start_date.format(
                        'ddd DD MMM, YYYY',
                    )}
                </span>
                <span className="time">
                    {props.slot.start_date.format(
                        'hh:mm A',
                    )}
                </span>
            </div>

            {props.appointment?.patient?.name && (
                <Grid
                    container
                    style={{ marginBottom: '5px' }}>
                    <Grid item xs={4}>
                        <span className="gray">
                            Patient:
                        </span>
                    </Grid>
                    <Grid item xs={8}>
                        <Typography
                            noWrap
                            className="black capitalize">
                            {props.appointment?.patient
                                ?.name ?? ''}
                        </Typography>
                    </Grid>
                </Grid>
            )}
            <Grid container style={{ marginBottom: '5px' }}>
                <Grid item xs={4}>
                    <span className="gray">With:</span>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        noWrap
                        className="black capitalize">
                        {props.appointment.provider.name}
                    </Typography>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: '5px' }}>
                <Grid item xs={4}>
                    <span className="gray">
                        Speciality:
                    </span>
                </Grid>
                <Grid item xs={8}>
                    <Typography
                        noWrap
                        className="black capitalize">
                        {
                            props.appointment.provider
                                .speciality?.name
                        }
                    </Typography>
                </Grid>
            </Grid>
            <Grid container style={{ marginBottom: '5px' }}>
                <Grid item xs={4}>
                    <span className="gray">Type:</span>
                </Grid>
                <Grid item xs={8}>
                    <Typography noWrap className="black">
                        {props.appointment.type ===
                        APPOINTMENT_TYPE.TELE_HEALTH
                            ? 'Tele-health'
                            : 'In-clinic'}
                    </Typography>
                </Grid>
            </Grid>
        </div>
    )
}

export default WeekCalendarEvent
